import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { constants, Button, DropdownField, Icon } from '@adc/ui-adc'
import styles from './styles.scss'

const { ColorNames } = constants
const cx = classNames.bind(styles)

const MAP_OPTIONS_ARRAY = [
  { text: 'List', value: 'list' },
  { text: 'Split', value: 'split' },
  { text: 'Map', value: 'map' },
]

const LayoutToggleButton = ({
  className = '',
  displayFloatingLayoutButton,
  isMapView,
  largeScreen,
  layoutMode,
  onChangeMode,
  hasListingSelected = false,
  children,
}) => {
  // Mobile / Tablet: Floating button (render outside of filters header)
  if (displayFloatingLayoutButton) {
    // In map view: show List + Filter button group
    if (isMapView) {
      return (
        <div
          className={cx('floating-button-group', className, {
            'with-listing': hasListingSelected,
          })}
        >
          <button
            className={cx('floating-mobile-button', 'grouped')}
            onClick={() => onChangeMode('list')}
            data-elm-id='mobile_map_list_button'
          >
            <Icon
              name='list'
              iconStyle='regular'
              color={ColorNames.White}
              size='medium'
            />
            <span>List</span>
          </button>
          {children && (
            <>
              <div className={cx('floating-button-divider')} />
              {children}
            </>
          )}
        </div>
      )
    }

    // In list view: single Map button
    return (
      <button
        className={cx('floating-mobile-button', className)}
        onClick={() => onChangeMode('map')}
        data-elm-id='mobile_list_map_button'
      >
        <Icon
          name='map'
          iconStyle='regular'
          color={ColorNames.White}
          size='medium'
        />
        <span>Map</span>
      </button>
    )
  }

  // Desktop: Dropdown menu
  if (largeScreen) {
    return (
      <DropdownField
        className={cx('map-layout-dropdown')}
        detachedMenu
        elmId='filters_map_view_toggle'
        icon={null}
        onChange={onChangeMode}
        options={MAP_OPTIONS_ARRAY}
        pointing='top right'
        search={false}
        value={layoutMode}
        style={{
          border: 0,
          padding: 0,
        }}
        trigger={
          <Button className={cx('map-layout-button')} role='secondary'>
            <Icon
              color={ColorNames.Info}
              iconStyle='regular'
              name='table-layout'
              size='large'
              style={{
                fontSize: 20,
                verticalAlign: 'text-top',
              }}
            />
            <span>Layout</span>
          </Button>
        }
      />
    )
  }

  // Laptop: Regular button (inside filters header)
  return (
    <Button
      className={cx('map-layout-button')}
      onClick={() => onChangeMode(isMapView ? 'list' : 'map')}
      role='secondary'
      style={{ borderColor: ColorNames.Gray }}
      onClickCapture={e => {
        e.currentTarget.blur()
      }}
    >
      <Icon
        name={isMapView ? 'list' : 'map'}
        iconStyle='regular'
        color={ColorNames.Gray}
        size='medium'
      />
      <span style={{ color: ColorNames.Gray }}>
        {isMapView ? 'List' : 'Map'}
      </span>
    </Button>
  )
}

LayoutToggleButton.propTypes = {
  className: PropTypes.string,
  largeScreen: PropTypes.bool.isRequired,
  displayFloatingLayoutButton: PropTypes.bool.isRequired,
  layoutMode: PropTypes.string.isRequired,
  isMapView: PropTypes.bool.isRequired,
  onChangeMode: PropTypes.func.isRequired,
  hasListingSelected: PropTypes.bool,
  children: PropTypes.node,
}

export default LayoutToggleButton
